
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Bersih`,
'deleteKey': `⌦ Hapus`,
'downKey': `↓ Turun`,
'endKey': `⤓ Akhir`,
'enterKey': `Masukkan`,
'escapeKey': `⎋ Melarikan diri`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Hasilkan 
          <code>LISENSI 
          </code> file 
        `,
'homeKey': `⤒ Beranda`,
'keyCommand': `⌘ Perintah/Menang`,
'keyControl': `^ Kontrol`,
'keyOption': `⌥ Opsi/Alt`,
'keyShift': `Shift`,
'leftKey': `← Kiri`,
'pagedownKey': `▼ Daftar Halaman`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Baiklah.`,
's00065e45db8c0441': `Lihat alat bantu pengembang untuk detail lebih lanjut`,
's001dd78415a91fa0': `Selokan bilah gulir`,
's002fa7d1054ed082': `Kotak perbatasan`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazakh`,
's01b56d233c6c5cac': `Bagian`,
's01d32b35baa3b676': `Penulis`,
's02106cc2ef0e7578': `Pin baru...`,
's02ab1ea8e5100fc1': `Tandai pilihan sebagai 'penggantian dua arah'`,
's0312976fe9da5951': `Tombol`,
's03608a32f05eded2': `Zoom cubit`,
's036d35e03be98d22': `Kedalaman matematika`,
's037b1dc850a89273': `Alternatif di bawah`,
's0396202b716732ec': `Tandai pilihan sebagai terserang`,
's03f49e598ffb11cc': `Polandia`,
's0448f1059fa01720': `Menyimpan, membagikan, atau mencetak hasil eksplorasi Anda. Mengedit informasi seperti judul, bahasa, atau lisensi.`,
's0458872c43beadef': `Sisipkan baris sebelum`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Spasi kata`,
's05e9759cfd99c48f': `Membenarkan`,
's063fa5a0a4903bf4': `Menyamping, dari kiri ke kanan`,
's064339c229374050': `Pengkodean`,
's06634274f19b0572': `Pemilihan pin`,
's06743b24499f0035': `Pusat jangkar`,
's07808b0ca6da8fef': `Situs web berpagar`,
's07970793b21351fd': `Wadah dasar Ruby`,
's079cf7850d9327f0': `Font`,
's07aa10850d9ddcc7': `Formulir`,
's07e6118e838b2e23': `Navigasi`,
's0816468df86e4036': `Membuka pengaturan`,
's082869038c117fe5': `Bahasa Portugis (Brasil)`,
's086e6c267ade2609': `Kejenuhan`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Menyisipkan daftar (tidak berurutan)`,
's09c3f1d21de14ae1': `Tandai pilihan seperti yang digarisbawahi`,
's0a2d91c6720033e9': `Memangkas jarak spasi teks`,
's0a3ddcba94027d95': `Kesesuaian objek`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Menyisipkan navigasi`,
's0a7db790db1fc45c': `Tandai pilihan sebagai rentang`,
's0b1271f50a77dc73': `Kotak konten`,
's0b24d08ea349b455': `Segala sesuatu yang bisa Anda sisipkan. Pada awalnya adalah elemen non-interaktif seperti daftar atau gambar, selanjutnya adalah elemen interaktif yang disebut widget. Anda bisa mendapatkan yang baru dengan mengklik bilah pencarian.`,
's0bdca49248ba4820': `Pintasan`,
's0befccf152b6c0a9': `Mengorientasikan dari metadata`,
's0c11e479416c8421': `Menyisipkan keterangan tabel`,
's0c27336067c59611': `Bantalan gulir`,
's0c4593d81f147042': `Baseline`,
's0c4b2e98d4ab7f5a': `Perintah aplikasi`,
's0c883713b83616a8': `Menyimpan dokumen yang sedang aktif`,
's0ca5c0460199cba1': `Singkatan`,
's0cf10c4f40588f8d': `Keterangan Tabel`,
's0d86afa3c6a1e28b': `Arah fleksibel`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Dokumen Anda yang dapat dieksplorasi. Anda dapat menulis teks dan menyalin/menempel, mengedit, dll. di sini.`,
's0dc452999c129e15': `Mengaktifkan pemuatan ulang langsung`,
's0de0febab8a4beaf': `Kesalahan membaca paket ini`,
's0e44968489e076a8': `Cina`,
's0e4862e87c7d53ce': `Tandai pilihan sebagai kutipan`,
's0e6ea8870dbddab2': `Perintah dokumen`,
's0ee28503778e4c0c': `Garis dasar terakhir`,
's0ef01c03299bbb83': `Dekorasi`,
's0f17f32919661cff': `Mongolia`,
's0f350bc4e538e3ea': `Kata-kata`,
's105a06836c40fcb4': `Menetapkan filter, warna, dan pencampuran elemen yang dipilih`,
's106b274b5af798e5': `Kalimat`,
's1082e1649793dca9': `Tandai pilihan sebagai istilah yang ditentukan`,
's10f3845975a0351e': `Edit Metadata`,
's1125d159f7e64df5': `Tampilan`,
's11326fd2590f4e5e': `Default`,
's1155ec07a221e739': `Bilah gulir`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Visibilitas`,
's123bea44f38abccf': `Menyisipkan objek`,
's1245e2cb9f20197e': `Sejajarkan`,
's12946ec1b850962c': `Sisipkan kolom setelah`,
's1351209ef74ee729': `Rentangkan semua kolom`,
's13c60cb409e8cb6f': `Sejajarkan pusat`,
's13ebd619c8a06a6d': `Baris otomatis kisi-kisi`,
's13ef8ca26ca8861b': `Elemen potong`,
's151bc2eea7a032a4': `-tidak berubah-`,
's153bc3c3aa39587b': `Kepala Meja`,
's156647179b21d351': `Menyisipkan badan tabel`,
's158b6ec6b1fffcb2': `Istirahat setelah`,
's15d0c0657c1ee08c': `Kunci API`,
's1626a7e10a9f9dcc': `Mengatur keluarga font pilihan`,
's1637c7d1a30629e2': `Kotak Perbatasan`,
's1641ab440bf4daa4': `Perbarui paket widget ini`,
's166bd56d19670a72': `Memperbesar`,
's1696c76a23c0834e': `Tingkat lanjut: Menampilkan paket dengan versi seperti 0.x.x di pengelola paket`,
's16b9446e3a70e1f4': `Atribut`,
's16f205466761e583': `Tidak ada ukuran font optik`,
's16f2f1c2c516d307': `Membuka dokumen`,
's1749014f3f87fa6a': `Peregangan`,
's17597a8bb4810524': `Lisensi`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Hapus bidang`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Buat paket`,
's18d5c44aae3dc82a': `Online saat mengedit`,
's1988d71ef8060edf': `Menyisipkan baris tabel`,
's19abee1277c9bca2': `Samoa`,
's19daf2f26c19543d': `Garis besar`,
's1a1acc902e6668e0': `Menampilkan pemformatan teks lanjutan`,
's1a5230a71d9285c1': `Menangkap`,
's1aa1cb63ad44bc6f': `Celah kolom`,
's1af8b67d1c85c811': `Ruang antara`,
's1b4a36fce2456660': `Keluarga Font`,
's1c246045629b0016': `Tandai pilihan sebagai penghapusan`,
's1c3fc313a9184670': `Tautan Publik`,
's1c65f5004a07dcfa': `Gaelik Skotlandia`,
's1c690963f1e2df00': `Tampilan khusus platform`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Ingin tur singkat dengan pemandu?`,
's1d19244f549ec535': `Pendidikan`,
's1d5c7b28e8b50d6d': `Derajat asosiasi.`,
's1db591f5a54dbfd3': `Kotak Konten`,
's1dbb9f50e16c92a3': `Radius perbatasan`,
's1dfb744260fb3a01': `Isolat Dua Arah`,
's1e9c2c654732cc5f': `Byelorusia`,
's1eaccbf2d6af8ab5': `Informasi`,
's1efbfc3937d565bd': `Latar Belakang`,
's1f2b49c1bca2035d': `Catalan`,
's1f74bdf32b51a5fc': `Gambar Latar Belakang`,
's1f7698c061c208c9': `Buka`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsika`,
's21d61916eb8d137d': `Badan Meja`,
's21d723a1dbcd89c8': `Bahasa Jawa`,
's21f8a2eaf5a70749': `Menyisipkan label`,
's2206c42e5b835e6e': `Tandai pilihan sebagai singkatan`,
's22a2348c46a912a0': `Menyisipkan bagian`,
's233ae776268cd44b': `Bisnis`,
's236ed7ba747099b0': `Berat font`,
's2474e7fb1aec9f05': `Tes`,
's2492f5fb1b05b45e': `Teks`,
's24949d7adbb5a098': `Kotak peralatan`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Membutuhkan atribusi?`,
's255857544a9d5ec0': `Atur ulang`,
's255c77900f2b5e0f': `Skema warna`,
's256ab831a48c941c': `Menghapus semua pemformatan teks dari pilihan`,
's2591806d7b222591': `Mengatur ulang perubahan`,
's25e1a07e454c2c11': `Grid`,
's262abbaf1d05f009': `Cahaya lembut`,
's266935f2447fcd98': `Lebih dari Kiri`,
's268ecd1cef45a9a8': `Apa kau yakin?`,
's2692bc028fed91f1': `⇪ Kunci Huruf Kapital`,
's27056379e0acfdb0': `Meringankan`,
's27076e66c5d483ba': `Menyelaraskan vertikal`,
's2712dc5641a33226': `Akun registri paket ditujukan untuk pengembang dan memungkinkan Anda untuk
          mengonfigurasi satu atau beberapa registri`,
's27cc88818cc46ff6': `Stabil`,
's281d957112b10f12': `Mengedit HTML dokumen secara langsung`,
's28b6246ce616a548': `Menyisipkan grup kolom tabel`,
's29a1c26521879b9f': `Perkecil skala`,
's29acfd2778e8c377': `Menyembunyikan pemformatan teks lanjutan`,
's29b24c06315e9343': `Memasukkan masukan`,
's29eb103449472e3b': `Menyisipkan judul (level 3)`,
's29ee7434494a0dfe': `Menyisipkan judul (level 2)`,
's29f21c34494d614d': `Menyisipkan judul (level 1)`,
's29fbfc3449557f72': `Menyisipkan judul (level 6)`,
's29ff743449588131': `Menyisipkan judul (level 5)`,
's2a031834495bcdb4': `Menyisipkan judul (level 4)`,
's2a75c946ef4dcab7': `Lain-lain`,
's2b2ae20d26f78ac2': `Blokir`,
's2b8f50c64be440f7': str`Pilih 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Pesan`,
's2bad2d24def4aa0b': `Jeda baris (bahasa CJK)`,
's2ceb11be2290bb1b': `Batal`,
's2ced8e8fafb499f6': `Menghapus elemen`,
's2d986d31f8d67357': `Menyisipkan satu set bidang`,
's2d995a37cf5e4995': `Menyisipkan NoScript`,
's2de969afacdaa7a6': `Bentuk`,
's2df075aface0dab8': `Bagikan`,
's2e192b19ed15fcf6': `Halaman`,
's2e39b99cf23606fa': `Mengatur tata letak elemen yang dipilih`,
's2e4818861000b13f': `Tata letak`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Melimpah (y)`,
's2edd6688a65e21f0': `Melimpah (x)`,
's2f0bcdffc92a786b': `Mengapung ke kanan`,
's2f2044f2431a32d5': `Judul`,
's2f4d4bfbc466d91f': `Bahasa Albania`,
's2f8da2cb5f236588': `Nama paket Anda. Harus dicakup, misalnya \`@org/pkg\`. `,
's30cce87854901922': `Prasekolah`,
's3124653c272f054c': `Warna aturan kolom`,
's314a4f7685c8e824': `Selalu`,
's31c06e226322f065': `Hindari anak yatim piatu`,
's323dcde72b850272': `Akses publik`,
's32911e52ee8ac745': `Memasukkan slot`,
's337a1e9022a8d19f': `Tabel`,
's33c1450d2822bb0f': `Menyisipkan keterangan gambar`,
's33c18d5a4cbffa2a': `Irlandia`,
's33f85f24c0f5f008': `Simpan`,
's342b0cabfa672822': `Bantu pengguna menemukan widget Anda`,
's3437e0d9899e7ae1': `Mengirim data telemetri tentang penggunaan WebWriter Anda.`,
's344ea8f4939cdc98': `Warna`,
's34dcda3b0f9d5a98': `Alihkan url`,
's34f724979a124c50': `Mengatur warna latar belakang teks yang dipilih`,
's355b21b89ce5d9c5': `Detail`,
's35ae5f4e0fa2777b': `Penyelarasan khusus`,
's35aeaff1425bca9e': `WebWriter tidak mendukung media dengan tipe `,
's35c3125c7750681e': `Kutipan blok`,
's3643189d1abbb7f4': `Kode`,
's3649bacefe731bf6': `Alihkan Kotak Alat`,
's365280e16a8ea32d': `Menyalin pilihan`,
's366991b9c9287765': `Benar.`,
's36a194e38d653a26': `Anotasi Data`,
's36b3cefdcb897f15': `Perspektif`,
's372fae706048ce41': `Ganjil genap`,
's377e24af9628c37e': `Daftar Pesanan`,
's37a8c35f6581da5f': `Tidak ada jangkar`,
's37fa3b9cd51c2dfd': `Mengatur ukuran font pilihan`,
's380d17664bb69531': `Sisipkan kolom sebelum`,
's3815184eb09f0dcf': `Kursor`,
's382a2aa3984474dd': `Membuat`,
's38980f98cb07ceb8': `Menyimpan dokumen aktif sebagai salinan`,
's3914cb410fca44d4': `Impor`,
's3a179f6db2972384': `Posisi Ruby`,
's3a5ca02f282d247e': `Bagikan...`,
's3ae67088bbefba98': `Paket`,
's3b0ab4b52326316f': `Cahaya`,
's3bdad99768e11911': `Dapat dieksplorasi`,
's3cb47df8290fa94c': `Menyisipkan opsi`,
's3cf89cb47fdde7e9': `Tautan`,
's3d09398e555ee5f9': `Opsi Lanjutan`,
's3d249bb480032121': `Daftar`,
's3d3efd1e19bdcfb4': `Anotasi Tanggal/Waktu`,
's3d6a732c792ccb9e': `Anotasi Ruby`,
's3d93f9ea0c5a13fa': `Gambar`,
's3d9548e211b958ce': `Lewati tumpang tindih`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Cantik.`,
's3eb6d1e6e79ed7c4': `Tidak ada dokumen yang ditemukan`,
's3eca5a034978754b': `Menghapus pilihan`,
's3f06e9abb6ebcb79': `Karakter`,
's3f1e7a3f2b283d3b': `Margin`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarat`,
's3f7e097a9b2e6181': `Menyisipkan artikel`,
's3fd83566dd643d10': `Menyisipkan legenda`,
's3fe72792941c18f9': `Teks bagian bawah`,
's3ffcdc5db5e7d0c5': `Membalikkan`,
's40e3826b7f74a3b5': `Pan (kanan)`,
's40f07d7859284a44': `Garis dasar yang dominan`,
's4101ada154a1b958': `Tengah`,
's410c465a5993f82d': `Peluang Pemutusan Jalur`,
's41322d19c928c603': `TEKNOLOGI INFORMASI DAN KOMUNIKASI`,
's417b90913e05bc17': `Pratinjau`,
's418f2020fe996832': `Mengonfirmasi perubahan`,
's41c724f0698148e9': `Tandai pilihan sebagai pintasan keyboard`,
's41f65a763f8e44ab': `Grup header tabel`,
's42721130228841b0': `Kotak stroke`,
's429bd646f1cf8bc6': `Akun Grammar LLM memungkinkan Anda menggunakan API Grammar LLM untuk mengoreksi tata bahasa dalam teks.`,
's429dd933ba95549b': `Memasukkan alamat`,
's42e470ef1d707a28': `Putar otomatis`,
's42ffdab1291fb3de': `Sisipkan baris setelah`,
's430831017f3f0499': `Kemiringan (y)`,
's430bd5017f42511c': `Kemiringan (x)`,
's433ba70286202ceb': `Hancurkan semua`,
's441b20a8a50e36b4': `Macedonia`,
's445b8acb9206db6e': `Buang dan batalkan`,
's446a924922651ea0': `Penekanan teks`,
's44cdba92713de38e': `Area kisi`,
's45518abd911471d0': `Kroasia`,
's456a8d744313852a': `Ruang di sekitar`,
's4634541f5056a546': `Abkhazian`,
's46d4abe6255cb9e1': `Menetapkan ulang pintasan`,
's4730c232e7209c40': `Pangkas keduanya`,
's474f0eec369d02a4': `Keluaran Sampel`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Tandai pilihan sebagai keterangan tanggal/waktu`,
's47ebf3a8fb3b10c1': `Orientasi`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opsi`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Bayangan teks`,
's4993444bfd3f3e5e': `Runtuh`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Topeng`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Utama`,
's4a894f57eba1cf1e': `Pintasan Papan Ketik`,
's4ac1ad6ecd6bd810': `Lain-lain. ed.`,
's4ad6e9d3c2365c98': `Cahaya keras`,
's4b2c143acf931122': `Tinggi garis`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Hindari halaman`,
's4c402ff5355fd310': `Pengabaian Dua Arah`,
's4caed5b7a7e5d89b': `Bahasa Inggris`,
's4cb38675a21b2c98': `Jenis properti yang tidak didukung '\${desc.type}' (diproses sebagai JSON)`,
's4cc8391f172c0cdf': `Bubarkan tur`,
's4d528b416ac8dee2': `Menyisipkan grup judul`,
's4d546f6c87128d5b': `Ruang pertama`,
's4dcb9315f6527f9c': `Jalankan saat memuat ulang`,
's4e191bdb4700a6e9': `Gulungan berlebih (x)`,
's4e1c7fdb470386ac': `Gulungan berlebih (y)`,
's4e2562fe3990e621': `Kesalahan menghubungkan`,
's4e361bf8eef3759a': `Istirahat kata`,
's4ea0f21fc2a338a1': `Pindah ke atas`,
's4eace13b3ed74187': `Komentar Samping`,
's4efee5b48a4593cb': `Lingkaran`,
's4f26e7cb7c0a8318': `Gambar Vektor`,
's4fd2e638aabb0bb3': `WebWriter mendukung penyematan berbagai sumber yang berbeda. Cukup tempelkan tautan
          ke konten:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thailand`,
's5015a8fb33b98872': `Tipis`,
's50489ffb1bde152e': `Penyisipan`,
's5068560b8d39663d': `Peta yang dapat diklik`,
's517acbf1f96324f9': `Berat`,
's523eb9043213ff0d': `Miring`,
's52777d434baeed9b': `Menyisipkan indikator kemajuan`,
's52af5d7ac34c2163': `Baris Tabel`,
's52e0bdc3ee304436': `Masukkan meteran`,
's531056f039febd39': `Menyisipkan pilihan`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Membuka atau menutup kotak alat (hanya pada layar yang sempit, jika tidak, kotak alat selalu terlihat di samping).`,
's5432ad3c84273229': `Gambar`,
's543906d1db8b2283': `Sunting `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kamboja`,
's54897f2764b0e4d0': `Instal paket widget ini`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Tandai pilihan sebagai sangat penting`,
's55905c735052d295': `Istirahat Tematik`,
's5590dbf7e425789d': `Label`,
's5623aa2f83b05c76': `Tibet`,
's564d1648b1ceee9f': `Terbaru`,
's565cd5ffb0158c46': `Hindari wilayah`,
's571a4f19e2f140c7': `Geser (x)`,
's571db319e2f4208a': `Geser (y)`,
's575e795c45e2d97e': `Kembali.`,
's5787c6d5b3b5541a': `Jalur klip`,
's579c69f419b6caef': `Halus`,
's587ac858dd80f6fa': `Subskrip`,
's58bec0ecd4f3ccd4': `Ketat`,
's59404f5593c32fdc': `Kerning font`,
's5941292bb77281ab': `Bokmål Norwegia`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Jauh`,
's5a1a0898baf20675': `Tandai pilihan dengan anotasi data`,
's5a356677b61a6b7e': `Moldavia`,
's5b474b5c0ac0c7c4': `Kelompok kolom tabel`,
's5b517ac216f9ee62': `Menyamping`,
's5b8cc9bb61ddce15': `Menyisipkan paragraf`,
's5bba2ac2e53bd1fd': `Kirghiz`,
's5be80ad6b8301710': `Mulai sebaris`,
's5c1ecf88259b79f9': `Presentasi`,
's5c2a1a52c0389c30': `Teknik`,
's5c63af7695445fcf': `Gaya Teks`,
's5d18ca4c3111be6f': `Menyisipkan kepala meja`,
's5d87c1e588f48d90': `Latihan`,
's5d929ff1619ac0c9': `Pencarian`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `otomatis`,
's5e27738a2e8eb763': `Masuk`,
's5e2cba97c0d971bd': `Paket isi ulang`,
's5e53415a6d5719ad': `Ilmu sosial`,
's5e6a7a0c30d2a270': `Lewati tumpang tindih (otomatis)`,
's5e9e8e4d21bafedc': `Produksi makanan`,
's5ed03bb1f3a15949': `Gambar`,
's5f43af3669b1e098': `Sumber`,
's5feaf7fd7ee567c8': `Istirahat kata`,
's600fd23c9ce971e8': `Mencetak dokumen yang sedang aktif`,
's602bbd28dae2c60f': `Mulai sendiri`,
's60ff598dfcf2c773': `Di bawah Kanan`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Kolom Tabel`,
's6196153c4b0c1ea0': `Memasang`,
's61c017f6d5c303af': `Frisian`,
's61ded17ca3f48c82': `Menggarisbawahi offset`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Pilihan salinan`,
's624e31cd4f1b89d4': `Gulir halus`,
's626daf42b1ab7df7': `Sejajarkan ke kiri`,
's6280bf993915c57a': `Margin gulir`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Deskripsi`,
's63dfc5b1c1c27849': `Yiddish`,
's63e03c70f67ebf9c': `Konteks`,
's63e71d20d1eaca93': `Bahasa Jerman`,
's640bc7710d0143ce': `Mengulangi perubahan terakhir yang dibatalkan dalam dokumen aktif`,
's64dc1fc7e3db45c9': `Membuat dokumen baru`,
's65ac276544ba33cd': `File SVG`,
's66765c420ee578e4': `Ruang secara merata`,
's669b18c6d2d9c95b': `Tidak ada`,
's6747dbf4ad6063ba': `Ujung sendiri`,
's6787497df07fa97e': `Dapat menggulir di atas pemberhentian`,
's67c2b60a506a09e4': `Edisi kedua.`,
's680bd4d926cd5a84': `Mempertahankan 3D`,
's6827930ef1aeaf99': `URL dasar`,
's684a16f3c711394d': `Di sebelah kanan.`,
's687e27f036a71b32': `Mengisolasi`,
's68b87d7b61052dc3': `Baris tabel`,
's68e0e3a2bab7ce3e': `Hindari`,
's690da6b432987c6f': `Mencadangkan perubahan pada dokumen saat ini secara otomatis. Perubahan akan dipulihkan saat WebWriter dimuat ulang.`,
's69311c4e25074fb3': `SMA`,
's697400b541fbc3cd': `Di bawah`,
's6988ab5d47593a26': `Anda memiliki versi terbaru WebWriter.`,
's69a49786a8009f43': `Temukan paket...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Penutup`,
's69fbbdb8ad2a084a': `Gelap`,
's6a31eff1ec4f71ad': `Menyembunyikan wajah belakang (3D)`,
's6ac62e1c8c66f3bb': `Superscr yang ringkas.`,
's6b585ba37cdb8260': `Mewarisi`,
's6b61f8abf89586be': `Bahasa Ibrani`,
's6bd7a02fdf93e653': `Menyelaraskan konten`,
's6cfc66b824ea05ba': `Tepi yang tajam`,
's6d02dc19e21eb49c': `Atas`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnam`,
's6d8b3b8047ed378d': `Mode campuran campuran`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Menyisipkan gaya`,
's6e288a119281f4c2': `Perenderan teks`,
's6e4c20c6debcd5ca': `Pembenaran khusus`,
's6f84199e62584905': `Teks yang telah diformat sebelumnya`,
's6fb3053e7244d326': `Bidang lainnya`,
's70178e04a3b691b6': `Buka Pengaturan`,
's7031ca562378bde6': `Presisi geometris`,
's7060970b5ed20a58': `Interaktivitas`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Menampilkan paket yang tidak stabil`,
's71dec51005acc1e4': `Baris padat`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Objek`,
's731678e227a20559': `Perangkat ini`,
's736904f276fbd441': `Ilmu pengetahuan alam`,
's739544d0c858c633': str`Atau jatuhkan 
          ${0} di sini 
        `,
's73cb20c838e761e1': `Pemilihan potongan`,
's7417792bbe720149': `Ulangi.`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Sisipkan ke samping`,
's744d993d03f29851': `Layar`,
's748c0074eff45884': `Manipulasi`,
's74aa0039a87141e2': `Elipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Isi kotak`,
's75109f5307578a61': `Selamat datang di WebWriter`,
's75a27f43413e02c5': `Bahasa Prancis`,
's75d83fc3f0cfab40': `Header`,
's762e5704cc84089d': `Menetapkan opsi gaya lain dari elemen yang dipilih`,
's77318393dfdb0775': `Hapus baris`,
's77e594ddcc10c774': `Mengizinkan penggunaan komersial?`,
's782eac2b3e80323d': `Tandai pilihan sebagai penekanan`,
's782f286a79cca35d': `Relatif`,
's78673a3539cb1915': `Kiri atas`,
's78789724e789221c': `Ukuran`,
's789ff24c8f03f1a4': `Spasi huruf`,
's7995733bf97c01cc': `Serbo-Kroasia`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Kesalahan dengan `,
's7ae49e142487766c': `Akses masyarakat`,
's7af555180b30a947': `Buka alat pengembang`,
's7b4ba250601b8667': `Menyisipkan templat`,
's7b560d8693ed8f42': `Tegak`,
's7b9994904c4f5b54': `Tajik`,
's7bdf0fd5b014d36c': `Pentingnya yang kuat`,
's7beb1e77e82363eb': `Membatalkan perubahan terakhir pada dokumen aktif`,
's7c61118554a0ec36': `Maksimum (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Perusahaan`,
's7cfe12cd14df9950': `Keluar`,
's7d27db3c9639c6dd': `Alternatif`,
's7d8103f6f06f83d6': `Padding`,
's7d864465dddbb50d': `Izinkan pengubahan ukuran`,
's7de0e28d6c309a4e': `Mengizinkan tindakan sentuh`,
's7dea785045c3cc74': `Tekan kombinasi tombol baru...`,
's7e0b179d4d1414eb': `Masukkan tautan`,
's7e6570f2f1ae320f': `Mensintesis jenis huruf`,
's7ecb1f29332293e5': `Garis dasar penyelarasan`,
's7ed13ccddb1bf3c3': `Hamparan`,
's7edbe0b213199995': `Sarjana`,
's7ede1c55e35ce9d6': `Simulasi`,
's7f09197a4814079b': `Mengatur opsi interaktivitas untuk elemen yang dipilih`,
's7f326a142e856656': `Gaya`,
's7fcb35d23be1e643': `Set Bidang`,
's80570196a9ce6d11': `Mengaktifkan telemetri`,
's806f84eb0ace116e': `Lihat apa yang telah Anda pilih dan ubahlah. Menyalin, memotong, menempel, menyematkan, atau membuat perubahan tata letak. Menawarkan pilihan yang berbeda tergantung pada pilihan Anda, misalnya pemformatan teks.`,
's80a42b81c52d4d8f': `Warna caret`,
's80b71fc6f43c5ce1': `Longgar`,
's812cbda653daaeba': `Fitur ini belum diimplementasikan`,
's81c3d8809658b951': `Kashmir`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Lanjutkan`,
's8247d32213e35f24': `Sisipkan utama`,
's82665b2ffabc9c0a': `Situs web`,
's828b1ecea8715884': `Pan (kiri)`,
's833bd0422a7ef95d': `Ukuran tab`,
's83420ad7b6a14db5': `Alihkan Alat Pengembangan`,
's83c15613b6f6f3c8': `Hanya online`,
's83cd32b685ccc9b7': `Kontrol`,
's83f26d02dd7aa681': `Terlihat`,
's840fa49e8989c028': `Posisi / Bentuk`,
's844a76d1843ceb3c': `Mengatur ulang ke default`,
's84e4e8ae645b82ac': `Kanan atas (y)`,
's84e9c7f8785ca60b': `Menyisipkan formulir`,
's8517ae4da104b004': `Kelompok Kolom Tabel`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Lisensi sebagai Creative Commons OER?`,
's85f9aa6d3ea0e421': `Grup footer tabel`,
's864b0e6270e97246': `Tandai pilihan sebagai komentar tambahan`,
's8670e5ad3bf0dcf8': `Simpan Sebagai`,
's8688d74dd3716d6e': `Pintasan keyboard untuk perintah`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Margin bentuk`,
's87cefc710b3567fb': `Berisi`,
's88676f992b2965db': `Meregangkan konten sel`,
's886897f2fd4edb99': `Tersembunyi`,
's886c5db2a5579873': `Konsep`,
's888c71e8fcb916d3': `Simpan otomatis`,
's88a62d29529948fb': `Menyisipkan tabel`,
's89950d86c8004d4b': `Lewati tidak ada tumpang tindih`,
's89bca7498f20e041': `Klip Latar Belakang`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Istirahat sebelum`,
's8a4ff2bd9c13498c': `Mencatat`,
's8a6585c48ea104e9': `Menyembunyikan sel kosong`,
's8a9eb438abac7c6a': `Label`,
's8b0432eecbd8b034': `Memperbarui`,
's8b7580c35e2aef87': `Kiri atas (y)`,
's8bc4affa761aa8a2': `Menyisipkan gambar`,
's8c7f51cb067644c7': `Daftar Data`,
's8d342ecaa9e75b9b': `Hubungan`,
's8d797888455f4147': `Istirahatkan spasi`,
's8d83386457e91813': `Batalkan/ulang perubahan Anda atau lihat pratinjau dari sudut pandang pelajar.`,
's8d8643013a7754d1': `Meratakan teks`,
's8df30fe2a50d3479': `Menyisipkan peluang jeda baris`,
's8e715248c3a78446': `Potong pilihan`,
's8f29e48d6b9a1aa8': `Menyisipkan baris header tabel`,
's8f4be9f086eb530f': `Membatalkan`,
's8f533296a536965e': `Simpan sebagai...`,
's8fad58c831ecf017': `Wadah teks Ruby`,
's8ffe7abcbed8eb43': `Vertikal, dari kiri ke kanan`,
's90105521fcc40453': `Akun WebWriter Cloud memungkinkan Anda menyimpan dokumen secara online dan
          membaginya dengan siswa. Tambahkan akun di sini dan akun tersebut akan tersedia sebagai
          lokasi untuk menyimpan, memuat, berbagi, dan membuka dokumen.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Palet font`,
's90f7c1cf501ea0a7': `Menghindari warna`,
's91093e0b087911ba': `Posisi penekanan`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Sisipkan sematan`,
's9219acd5bef6269e': `Di bawah kiri`,
's92548405912d46bf': `Jepret gulir sejajar (y)`,
's9258280591309342': `Jepret gulir sejajar (x)`,
's927d796559f49439': `Latar Belakang Asal`,
's92b177e579ef7b97': `Penekanan`,
's92f846b9be2e8e8d': `Tandai pilihan sebagai huruf miring`,
's93566b84230af4f5': `Menyisipkan gambar`,
's936aa0b239679585': `Menyisipkan jeda tematik (biasanya ditampilkan sebagai garis horizontal)`,
's9370dc6afa716b57': `Perbatasan`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Istilah yang Ditetapkan`,
's9485af2e7cd9418f': `Sekolah Dasar`,
's94d2eee44b292567': `Beralih ke opsi lanjutan`,
's94d61907ee22a8c1': `Bahasa Korea`,
's94eb1effbbb6498b': `Meluap`,
's951aa3a6439f1271': `Penanda daftar`,
's9565553d163fc92a': `Script`,
's957787fc6b7ea5c0': `Pan (atas)`,
's95d56e58f816d211': `Belanda`,
's95d8e41a64635c7c': `Ruang putih`,
's95de7e1eff6c053e': `Horisontal, dari atas ke bawah`,
's960d3a90ac199368': `Rhaeto-Rumania`,
's96532132a29dd542': `Menyisipkan audio`,
's96a045dcade75ad0': `Kolom padat`,
's9781a5bb3fcb26a3': `Pilih perusahaan terlebih dahulu`,
's978522fbc9577a7e': `Somalia`,
's97881699a2b21d5b': `Celah baris`,
's97aa76056a81bd36': `Metrik`,
's986facb3ecc9602c': `Menyamping, dari kanan ke kiri`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Berkas Eksternal`,
's98977a87d1b93941': `Mengatur ulang informasi, gaya, dan skrip`,
's990d0e0fa2ab00b5': `Galicia`,
's99229574e5692f19': `Greenland`,
's99a990f3841ad283': `File dari `,
's99b38e000175cc84': `Dicoret`,
's99f110d27e30b289': `Judul`,
's9ab10fbf4c7a7322': `Posisi garis bawah`,
's9abadcc828884d7b': `Textarea`,
's9b7cd8860c8fc922': str`
          ${0}
          akan ditimpa. Apa kau yakin? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Warna Latar Belakang`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Kolom tabel`,
's9cf68f87b8e6122f': `Azerbaijan`,
's9d167ef77aed79b6': `Lapisan`,
's9d2d00982edafabb': `Bahasa Turki`,
's9d430adc5be110e9': `Baris Terbalik`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Penghapusan`,
's9df571714a1efb44': `Versi otomatis dari eksplorasi ini tersedia. Memuatnya?`,
's9e28faa598332e2b': `Menyisipkan video`,
's9e3dbb678150edd4': `Mengatur keluarga font`,
's9e40e59654c8ad67': `Kolom`,
's9e85800d3700e31c': `Melacak`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Varian font`,
's9f1ecdb3061d9cbc': `Melestarikan ruang`,
's9faf26107ed49fb9': `Menyisipkan sel tabel`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Transisi`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Kanvas`,
'sa00df4e39c72d3b4': str`
          ${0} tidak didukung 
        `,
'sa013e119fec906fb': `Baris`,
'sa01e7bf33563ef72': `Lampiran Latar Belakang`,
'sa126cf8c627cec1e': `Rendering gambar`,
'sa13f72278add7513': `Di bawah kanan`,
'sa1647e3b36ec08d7': `Kombinasikan tegak`,
'sa172190ea21f9b1c': `Mengakses pengaturan, membuka pengaturan yang dapat dieksplorasi atau membuat pengaturan baru.`,
'sa1c6c459b9b5115c': `Mutlak`,
'sa2cba871f6cdd99f': `Assam`,
'sa2eff4dad1c119f1': `Templat kisi`,
'sa30c12014e955946': `Rusia`,
'sa30f1981fd1cd441': `Ukuran huruf`,
'sa311a24c1471a974': `Dokumen`,
'sa352d168b262aa06': `Menyisipkan catatan kaki`,
'sa37fee6a52d18063': `Menghapus dokumen`,
'sa39c7ac1d37f3bce': `Tandai pilihan sebagai 'isolat dua arah'`,
'sa3b4c01623211544': `Memaksa`,
'sa40fd43756fa8913': `Persia`,
'sa417644bef21a9aa': `Tema yang tidak disebutkan namanya`,
'sa43800e28be1bdbc': `Warna dekorasi`,
'sa477cb1825dceb3b': `Sudan`,
'sa492a51a707930fa': `Menyisipkan kutipan blok`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Keterangan di bagian bawah`,
'sa50d3c35533f1d99': `Semua bidang`,
'sa53c5cb03a8fda50': `Sematkan pilihan sebagai cuplikan dalam palet`,
'sa557ae6bee9148a6': `Kemajuan`,
'sa589e1df65dde0ec': `Menetapkan ukuran, padding, dan margin elemen yang dipilih`,
'sa5c371b4bb75e590': `Kiri`,
'sa5c80e623459ffe4': `Menyisipkan tajuk`,
'sa5df1bcdba46c3fb': `Keterangan Gambar`,
'sa602e3fd3f2d98fd': `Animasi`,
'sa644d580d8a11e60': `Penjajaran Ruby`,
'sa645d315510dc09e': `Memilih jalur dari disk`,
'sa65d4ad99f1d8c06': `Mengatur latar belakang teks`,
'sa6607436f60ccc1a': `Estonia`,
'sa6f8d27bca557059': `Pindahkan elemen meta/tautan/gaya ke atas/bawah ke dalam elemen ini`,
'sa757645ad842da97': `Pertahankan istirahat`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Gulir`,
'sa778acc33947c7b8': `Selesaikan tur`,
'sa78a67272a4a6f95': `Rumus Matematika`,
'sa79167651dce1e80': `Teks alternatif`,
'sa7af797a46c7d09a': `Footer Tabel`,
'sa7dbe35b758c138d': `Menyisipkan kanvas`,
'sa7dc6b8ef3f595dc': `Menyisipkan sumber`,
'sa8279f8211b3950d': `Mempertahankan waktu istirahat dan ruang`,
'sa8b55cab62e439b5': `Hapus kolom`,
'sa8bbe0197d31b423': `Deskripsi singkat`,
'sa9ff3b762365abe6': `Mengubah asal (z)`,
'saa02e3762368ff35': `Mengubah asal (y)`,
'saa065776236bfa28': `Mengubah asal (x)`,
'saa33768e03c45fc8': `Ukuran file`,
'saaad98061a20ac39': `Menyisipkan rumus matematika`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Bergantian`,
'saaec15c97a9e4245': `Kolom Terbalik`,
'sab0c57df694a0a09': `Pangkas mulai`,
'sab4d9283896d9422': `Piksel resolusi jepret`,
'sab55faae8e165407': `Padding&lt;br&gt; seperti celah`,
'sab5e7d2a069a2951': `Sertifikat kejuruan.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Sejajarkan dengan benar`,
'sac895c732f350ac5': `Gelap`,
'saced41ddda8b2354': `Dasar yang fleksibel`,
'sad190f86451081c0': `Nepal`,
'sad6be321164d08c8': `Matematika yang ringkas`,
'sadd352cc7f6f2307': `Selain`,
'sae098810f946ca7c': `Bahasa Tagalog`,
'sae185e6af80ec81e': `Swedia`,
'sae1c7f13b7c0c47f': `Mulai`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Menyisipkan daftar deskripsi (glosarium, daftar istilah)`,
'saf3da7c95cb17260': `Tandai pilihan sebagai superskrip`,
'saf440a0a592f2835': `Perbarui ke`,
'saf9e5134ba1a7d30': `Jepret gulir`,
'safc6f203342d09e2': `Mengaktifkan pratinjau untuk dokumen aktif`,
'sb0a7e3adf4a125ee': `Kanan atas`,
'sb0a974028c99ca6d': `Mengizinkan adaptasi?`,
'sb0d4f0f7993cf085': `Mengatur ukuran font`,
'sb0f3327210fe18fc': `Kolom`,
'sb0f93c1c60c0249a': `Basis Ruby`,
'sb1494c08c8c720d1': `Mengatur warna teks`,
'sb19611adbc88f711': `Tingkat Lanjut: Menampilkan perintah pengeditan sumber, misalnya untuk menampilkan HTML dokumen atau menambahkan gaya dan skrip khusus.`,
'sb206d700d26b14ff': `Garis bawahi`,
'sb233557012dcb328': `Pindah ke bawah`,
'sb26035b596566abf': `Tidak disebutkan namanya`,
'sb2cda80610c8d6ea': `Ruang semua`,
'sb2dc787b0983ebc6': `Lithuania`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Pusat`,
'sb3ba3276ae93627c': `Menyisipkan blok teks yang telah diformat sebelumnya`,
'sb430f5b4824de0d3': `Pilih tata letak`,
'sb43db07b24da018a': `Amharic`,
'sb45f9fb4dba6e71a': `Belum diatur`,
'sb4e003a459464d85': `Kurdi`,
'sb4f0310e6787d098': `Uzbek`,
'sb4f1dffbb6be6302': `Jelas`,
'sb51270e19988f9bd': `Wilayah`,
'sb59d621e3c93cc27': `Batas sel bersama`,
'sb5e9e1776242b028': `Interaksi`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doktor`,
'sb6103872073d369e': `Masukkan detail`,
'sb616811735bfbafd': `Sel tabel`,
'sb628960829e223bb': `Lewati semua tumpang tindih`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Terapkan dan impor`,
'sb66e2181a7b5738a': `Dengan mengaktifkan telemetri, Anda mengizinkan pengumpulan dan penyimpanan data sesuai dengan kebijakan kami`,
'sb67e0e7c0869f982': `Perbedaan`,
'sb68e83cda6c85af8': `Header tabel`,
'sb6b268120592dc53': `Bahasa Hindi`,
'sb6ca0a8bb3caae69': `Ketebalan dekorasi`,
'sb70c17f7899f9b01': `Bahasa Latin`,
'sb71941f552f3504d': `Tetapkan nilai khusus`,
'sb740eab4afd5a710': `Aliran otomatis kisi-kisi`,
'sb741b6e0ca589122': `Kembalikan lapisan`,
'sb7c77d0415de05cf': `Jalankan tes`,
'sb7fb7568f6883ab8': `Membagikan dokumen aktif`,
'sb85774dc5d18ff0f': `Konfirmasi`,
'sb85b1e36579852a6': `Email atau kata sandi tidak valid`,
'sb884fa76bfc55429': `Bahasa Arab`,
'sb8a3d4df7d1c5e6b': `Keseimbangan`,
'sb8f610a0e8df91fc': `Luminositas`,
'sb8f855b49234b81b': `Menerapkan`,
'sb905da066c10182c': `Ditambah lebih gelap`,
'sb940ade1bd81be7e': `Di bawah Kiri`,
'sb9e9a7dd45966756': `Tandai pilihan sebagai tebal`,
'sba509fd8ed61d1d5': `File yang belum disimpan`,
'sba64d8954d027206': `Keburaman`,
'sba88d90cd6c751b3': `Aturan kolom`,
'sbaf0a7c417e388af': `Kesehatan`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filter latar belakang`,
'sbb85a407d730e13d': `Memasukkan pencarian`,
'sbb86c6c96f598bb8': `Campuran`,
'sbba0156f795d8c07': `Pilihan edit`,
'sbba865d4b437944f': `Atribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Copot pemasangan`,
'sbc5f2a81604baf9b': `Judul 6`,
'sbc5f2b81604bb14e': `Judul 5`,
'sbc5f2c81604bb301': `Judul 4`,
'sbc5f2d81604bb4b4': `Judul 3`,
'sbc5f2e81604bb667': `Judul 2`,
'sbc6953a36ced943f': `kebijakan privasi`,
'sbd181cd54b8402a4': `Mengedit pilihan`,
'sbd35ee879d9cf770': `Teks Ruby`,
'sbd40f40cbadd38d5': `Hapus paket widget ini`,
'sbd72dc858de95ce8': `Burma`,
'sbe3c60c65f129daa': `Humaniora`,
'sbe4a7c8f231739b3': `atau tempel/jatuhkan/ambil file`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Menyisipkan jeda baris`,
'sbf00e1ee999ea94e': `Menyisipkan skrip`,
'sbf519920c2017d67': `Menggantung`,
'sbfa01f189a68d3e9': `Tumbuh dengan fleksibel`,
'sbff54e740c4086eb': `Tampilkan paket yang tidak dikenal`,
'sbfff51feacf30196': `Bahasa Sanskerta`,
'sc0ceaa9843510f67': `Turkmenistan`,
'sc1611c0558728a2a': `Posisi`,
'sc1a155cc25899250': `Grup baris tabel`,
'sc1aa1f6051b7102a': `Rumania`,
'sc1edebeaef92b7bd': `Tata letak tabel tetap`,
'sc1fff4f356dfb2fb': `Mengubah`,
'sc24bda3c061fddf8': `Area yang dapat diklik`,
'sc252a4e091763606': `Menyisipkan footer tabel`,
'sc2536e077514accc': `Menggulir`,
'sc275dd00036d16cb': `Mengutip karakter`,
'sc28864200d2a3799': `Salin Kode QR sebagai gambar`,
'sc2a24a9dd41a9503': `Garis dekorasi`,
'sc2b734cca2fa643b': `Geser (ke bawah)`,
'sc2e2a0dbf03723b7': `Tingkat lanjut: Menampilkan paket dari sumber yang tidak dikenal di pengelola paket (Peringatan: Mungkin tidak aman)`,
'sc3998b77d72c2932': `Menyisipkan situs web (sebagai bingkai sebaris)`,
'sc3ac225273c8316b': `Umum`,
'sc3cfee84dbbf36ae': `Berkas Lokal`,
'sc3f09a9b6fa4fbed': `Di dalam`,
'sc43767deea72e9f3': `Daftar Deskripsi`,
'sc462bbdd36bcba6b': `Kotak referensi`,
'sc4ee3e4ee994dafd': `Ukraina`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Asal perspektif (y)`,
'sc52e8b794c0913d6': `Asal perspektif (x)`,
'sc53de149fcaad713': `Antar-karakter`,
'sc546f489f9c0cced': `Mengalihkan mode pengujian untuk dokumen yang sedang aktif`,
'sc5bcf50d1b578d9f': `Pengaturan fitur font`,
'sc5cb39478b9b7625': `Tandai pilihan sebagai subskrip`,
'sc6415b50ff928294': `Daftar item`,
'sc650ff15b20fe9d3': `Memutar (z)`,
'sc6578b15b2154365': `Putar (x)`,
'sc65aff15b2183e58': `Putar (y)`,
'sc6da0f4a7e4d710e': `Penggantian bahasa font`,
'sc74e3567875ce255': `Baik tag widget Anda maupun nama paket NPM Anda`,
'sc7eb080b96e244df': `Bahasa Melayu`,
'sc8ac7ef92b95df3f': `Pindah (x)`,
'sc8af536e2084ade0': `Palet`,
'sc8b022f92b992bc2': `Pindah (y)`,
'sc8b39af92b9c2d81': `Pindah (z)`,
'sc8d2c7f6c33a2b32': `Mengatur gaya teks (perataan, lekukan, spasi, dll.) dari elemen yang dipilih`,
'sc8fa0e3de389ef1c': `Menyesuaikan ukuran huruf`,
'sc9474bf7a0668d73': `Ringkasan`,
'sc94e314312a8900c': `Ceko`,
'sc980855a000b76ea': `Bawah`,
'sc98b103772de63f4': `Finlandia`,
'sca7cfe2bef51b2a5': `Akar`,
'sca7fed2bef53cb99': `Peran`,
'scabe6ecee5e01fd2': `Malta`,
'scace301a88231cce': `Sematkan`,
'scbc55f622ec078c1': `Lihat kotak`,
'scbe537fc38ff4c13': `Kolom otomatis kisi-kisi`,
'scc1db59d292cbc4c': `Bagian`,
'scc56b218a2689c42': `Armenia`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Kotak Bantalan`,
'scd9cedeb5ece3adb': `Hyphenate`,
'scdf536b65be39ec5': ` Membuat/mengimpor`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografis`,
'sceecdd0bb404bc17': `Menyisipkan grup opsi`,
'scf00d48fd5953a03': `Bahasa Yunani`,
'scf932840a69dbb7c': `Bahasa Portugis`,
'scf932a8577057752': `Footer`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Kanan bawah`,
'sd01178c54f648118': `Kolom keseimbangan`,
'sd03bff50f87f82d4': `Karakter tanda hubung`,
'sd05a155fe09c2866': `Online saat menggunakan`,
'sd0864ea6cb6ef22e': `Komunitas`,
'sd10fdbe6caf9a998': `Jeda Baris`,
'sd121d3b959b7888d': `Optimalkan kecepatan`,
'sd1a78e667a1a139f': `Tandai pilihan sebagai penyisipan`,
'sd1cffad290ea5b3b': `Jauhkan semua`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `Email`,
'sd1f81984eeb7c0e8': `Isi`,
'sd29dc07235eea0f5': `Kutipan`,
'sd2addf69477cd4b4': `Paket impor`,
'sd2ed26defc646d47': `Filter Latar Belakang`,
'sd2ef82b8ea877c6d': `Bahasa Afrikaans`,
'sd319aae1401f1e19': `Tetap`,
'sd3a288c1094b8a63': `Lebar aturan kolom`,
'sd3c65ef5c380c046': `Inset`,
'sd3dcb76f7b28adb8': `Latvia`,
'sd3eca1e0f4209f6e': `Pangkas semua`,
'sd3f402df8619ddcd': `Informasi tentang Anda ini secara otomatis ditambahkan ke dokumen baru. Anda dapat
          mengubahnya untuk setiap dokumen di editor metadata.`,
'sd4368b12645d3c0f': `Menyisipkan portal`,
'sd452cebf4a0313d1': `Menampilkan perintah pengeditan sumber`,
'sd48cc52117f4d68b': `Bahasa Italia`,
'sd52660ee947ca58b': `Menyisipkan kolom tabel`,
'sd588d17a1b25c220': `Teks melimpah`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Pendidikan tinggi.`,
'sd5cf95145e4d89ca': `Lepaskan pin cuplikan ini`,
'sd5fd9d11a92f5b1d': `Kiri bawah (y)`,
'sd60c9bbc51375635': `Menyisipkan tombol`,
'sd66c4767fa3dde28': `Warna aksen`,
'sd679c8b1bf8cc8a5': `Topi kecil`,
'sd7086c4425c53c80': `Keluarga font`,
'sd837f42ac7cbfb58': `Bentuk (luar)`,
'sd88076d2994ee0fb': `Pengecualian`,
'sd89a2e529b31ef43': `Kembalikan`,
'sd8a345e95668b73b': `Vertikal, dari kanan ke kiri`,
'sd8ce9e57270b030d': `Peregangan font`,
'sd8ecf227c7c49331': `Matematika`,
'sd8f923198e0c5c6a': `Akhir`,
'sd9c21e5f60d6bdd8': `Denmark`,
'sd9ff8e2612e63d50': `Ukuran kotak perbatasan`,
'sda2d76b976502a8d': `Buka...`,
'sda344aacb837387e': `Posisi dalam wadah`,
'sda5b6fa8b771f996': `Mengapung ke kiri`,
'sda9254d1f1228e1a': `Hongaria`,
'sdb1595f5c742dfbb': `Masukan`,
'sdb711380a28fec75': `Menyisipkan daftar (dipesan)`,
'sdb73788b3c975f16': `Otomatis`,
'sdbee7e0523a23a42': `Kanan bawah (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Georgia`,
'sdd1ff479d04ac140': `Publik`,
'sdd2fc8919a9c3111': `Mode perpaduan latar belakang`,
'sdd35b688281b6dea': `Bahasa Jepang`,
'sddc49047f66a64ab': `Tidak ada deskripsi yang diberikan`,
'sdef34fe08bb28b09': `Bahasa Mandarin (Sederhana)`,
'sdf62e305e1594805': `Tandai pilihan dengan anotasi ruby`,
'sdf946172dfa0328f': `Superskrip`,
'sdf9bc5d9b7f3e3de': `Penjajaran`,
'se036b53f145441cd': `Konten Campuran`,
'se06f459fccdc3ce9': `Meratakan baris teks terakhir`,
'se0a782a8be8e018b': `Norwegia`,
'se0cda6b80a1bb50f': `Slowakia`,
'se0f67eae944f8f94': `Bisu`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikel`,
'se1f5bb0386c88f96': `Mengatur warna teks yang dipilih`,
'se219da7b1e955c65': `Hapus pemformatan`,
'se25e4f2cb77b8be8': `Bahasa untuk antarmuka WebWriter dan dokumen baru`,
'se2796c5824ec8916': `Visibilitas konten`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Di mana saja`,
'se39c065efa467782': `Basque`,
'se3b4c857f91f80d7': `Pintasan papan ketik`,
'se47baf2fd16b9d2b': `Templat`,
'se48bd9e6c2a3109d': `Akun`,
'se58467472725ad0c': `Resolusi gambar`,
'se58f06c2b0583ff7': `Pilih koordinat`,
'se5dc1e97fb743ade': `Jarak`,
'se619a501d1bfe6a5': `Bungkus`,
'se62385ac082368d2': `Tandai pilihan sebagai sumber kutipan`,
'se6297163cac9d276': `Sunting sumber`,
'se633223a0b88625e': `Penempatan sel`,
'se638417c560cfe5c': `Masuk ke dalam`,
'se64f418b4e733b6c': `Menyisipkan keluaran`,
'se79c0a3ac70d8fb3': `Asp. rasio (x)`,
'se79fae3ac710dc36': `Asp. rasio (y)`,
'se7fad370d8fb4cec': `Mengoptimalkan keterbacaan`,
'se8a94b4effa2033e': `Abjad`,
'se95d4e55ea186d9a': `Warna bilah gulir`,
'se96d43a515b8451c': `Slovenia`,
'se96fd76ba1b2975a': `Pusat`,
'se9ac05f36b004eb0': `Menyembunyikan tur pengantar. Nonaktifkan agar tur ditampilkan lagi.`,
'se9b1fec72ffd8f48': `Lokal`,
'sea24bdcaa2bd2dec': `Jepretan wajib`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Mengaktifkan editor metadata`,
'sea896ed51ad33287': `Tidak ada gaya khusus yang tersedia`,
'seaaaeb09e3b4e78b': `Perintah pengeditan`,
'seabae79729c4b2ad': `Alihkan email`,
'seaecc8267bad6234': `Sekolah menengah`,
'seaf97719986faf4f': `Kesenjangan`,
'seb19675a580f0628': `Hindari kolom`,
'seb4e52ef5ec7a7dc': `Warna/Efek`,
'seb8982ae8c3cdcc5': `Bahasa Indonesia`,
'sebbced89e0db2894': `Garis dasar pertama`,
'sec02109a0dd2a6c8': `Warna penekanan`,
'sec2557a35b702525': `Variabel`,
'sec2da4aa7a02b925': `Islandia`,
'sec30fbb20f102670': `Menyisipkan ringkasan`,
'sec8b0b6c729816b6': `Kelompok Judul`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `Direktori tempat package.json berada`,
'sed318ec045c5144f': `Ganti.`,
'sed713f1b916fb469': `Jarak batas (x)`,
'sed74a31b9172942c': `Jarak batas (y)`,
'sed86bd0deb2e5372': `Mengubah teks`,
'see2fcaedf9743ec6': `Lokasi`,
'seec6798afe90ffc8': `Mencetak`,
'sef00c258bc1ecf1e': `Penjelajahan ini memiliki perubahan yang belum disimpan.`,
'sef23dd271edd4a8b': `Kiri bawah`,
'sef24caccbd4645ef': `Menyusut secara fleksibel`,
'sef49aec68fd1dc66': `Nama`,
'sef73fe18e351eb35': `Kata kunci`,
'sef75f458d77491af': `Kelompok Opsi`,
'sefcf950b3cc4fc3b': `Bahasa`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Isi`,
'sf0cab2483f66aa2e': `Kustom`,
'sf0e261e04eda82ff': `Penampilan`,
'sf1045382c1fd9a85': `Warna cetak yang tepat`,
'sf14c35392ec7bf10': `Fitur ini tidak tersedia di Firefox. Fitur ini tersedia di Chrome atau Edge.`,
'sf14f9d5f9f6ca342': `Ditambah lebih ringan`,
'sf1868dc19e3917bb': `Bahasa Spanyol`,
'sf190149f9d8bbb2a': `Mode penulisan`,
'sf1e79171c4856543': `Apakah Anda yakin? Tindakan ini tidak dapat dibatalkan, semua pengaturan Anda akan
          dihapus dan diatur ulang.`,
'sf21c1f60c7515f44': `Tandai pilihan sebagai keluaran sampel`,
'sf21fb4f4b9e8911f': `Lebar`,
'sf22a3737146ec910': `WebWriter dapat menyematkan SVG secara langsung di dalam dokumen.`,
'sf2514d5dc78b1654': `Sisipkan widget`,
'sf28903d4ca0ddcfc': `Hapus akun ini`,
'sf2ab37af0abc55ef': `Sembunyikan tur pengenalan`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Mengubah ukuran secara horizontal dan vertikal`,
'sf2d5cbc2fe0ad65a': `Lengket`,
'sf2d96d0eb32cb81f': `Komposisi animasi`,
'sf2de3dbe2108637a': `Rendering bentuk`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Sebaris`,
'sf39736a666dbb038': `Menyisipkan trek`,
'sf3c4da68b08a2590': `Malagasi`,
'sf471ec2496f904cc': `Buang perubahan`,
'sf4849bc200e279ed': `Keterangan tabel`,
'sf486ca1fdbe08645': `Menyisipkan gambar`,
'sf4b537d4cbd8f5fd': `Teks atas`,
'sf4e0e02a5277ef23': `Menyisipkan area teks`,
'sf4f067d41efd4b83': `Skala (y)`,
'sf4f3cbd41f002b46': `Skala (x)`,
'sf4fa67d41f05a008': `Skala (z)`,
'sf5197db2d5f2926a': `Putar`,
'sf52d840949a980d1': str`
          ${0}
          akan dihapus secara permanen. Apakah Anda yakin? 
        `,
'sf55d634dcc743595': `Layanan`,
'sf59c9081d106dd9c': `Tandai pilihan sebagai variabel`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Menghapus dokumen`,
'sf65df67a03bebe4b': `Diperlukan untuk widget ini`,
'sf6673729c03ae999': `Setel Ulang WebWriter`,
'sf67571992e7dc88e': `Jangka Waktu Penuh`,
'sf6b4934598f7ed10': `Izinkan pemilihan`,
'sf6e1665c7022a1f8': `Kata sandi`,
'sf79e0d78b56444f1': `Ujung sebaris`,
'sf7a5f7a7c80c3082': `Keduanya`,
'sf7c0eba7c822e3d6': `Tebal`,
'sf86bd4d2982f3b74': `Tandai pilihan sebagai kode`,
'sf8e82313fa411494': `Tandai pilihan sebagai tautan`,
'sf955eff73fb6b573': `Serbia`,
'sf9929e2d356260c5': `Mengalikan`,
'sf993bb199fefbe04': `Semua`,
'sf9ecf969dd4b8164': `Kedua tepi`,
'sf9f2c719a04066ec': `Aplikasi`,
'sfa49a5bb1a5d353e': `Akses pribadi`,
'sfa59c7777e2a0eeb': `Menyisipkan daftar data`,
'sfaa0a67db5c11f72': `Indentasi baris teks pertama`,
'sfb231a52211b133f': `Tidak ada bungkus teks`,
'sfb68cae41d749423': `Awal`,
'sfb9b6edb0ed378c9': `Sumber Kutipan`,
'sfbbab09dbe553571': `Menyisipkan gambar vektor (SVG)`,
'sfc00292e778b67e2': `Meteran`,
'sfc63e31ac7c956ed': `Pilih`,
'sfc815c9078bba30a': `Unduh Kode QR sebagai gambar`,
'sfcdd8e672c75b713': `Alamat`,
'sfcebd18506f1e535': `Aliran`,
'sfd0cde85070d2eb2': `Fleksibilitas`,
'sfd77270c3f54f664': `Keluaran`,
'sfdb1e4d90981a535': `Bagikan dokumen ini`,
'sfdeef3dccf409f81': `Kata kunci ini diperlukan untuk widget`,
'sfe6e758ad2603c1d': `Master`,
'sfee1c12daf838935': `Warna terbakar`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Menyisipkan dialog`,
'sffa395f64ec6ac36': `Bulgaria`,
'sffdadf0a576fd802': `Tinggi badan`,
'spaceKey': `Ruang`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Naik`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  